<lib-dialog-layout>
    <ng-container title>
        {{data.Title}}
    </ng-container>
    <ng-container content>
        <lib-upload
            (RetrieveFiles)="EmitFiles($event)"
            (RemoveFiles)="EmitFiles($event)"
            [useNewStyle]="true"
            [acceptedFormat]="data.AcceptedFormat"
            [allowMultiFileUpload]="data.AllowMultiFileUpload"
            [maxAllowedFilesize]="data.MaxAllowedFilesize"
            [control]="data.Control"
            [hideInlineErrors]="data.HideInlineErrors">
        </lib-upload>

        @if (data.Control && data.HideInlineErrors && data.Control.errors?.max) {
            <div class="mt-3">
                @let namesAboveMaxSize = (files | method: GetNamesAboveMaxSize);
                <lib-banner
                    [isDismissable]="false"
                    [kind]="StatusKind.Danger">
                    <ng-container text>
                        @if (data.Control.value.length === 1) {
                            <ng-container i18n="@@UploadDialogSingleFileTooLarge">
                                Sorry, the file you're trying to upload is too large. Please upload a file no larger than 2GB.
                            </ng-container>
                        } @else {
                            <ng-container i18n="@@UploadDialogMultiFileTooLarge">
                                Sorry, some of the files you're trying to upload are too large. Please upload a file no larger than 2GB.
                            </ng-container>
                            @if(namesAboveMaxSize.length <= 3) {
                                @for(fileName of namesAboveMaxSize; track fileName) {
                                    <li>{{fileName}}</li>
                                }
                            }
                        }
                    </ng-container>
                </lib-banner>
                @if(namesAboveMaxSize.length > 3) {
                    <div class="margin-top-16">
                        <lib-clipboard-card-scroll>
                            <ng-container body>
                                <ul class="margin-bottom-0 padding-left-16">
                                    @for(fileName of namesAboveMaxSize; track fileName) {
                                        <li>{{fileName}}</li>
                                    }
                                </ul>
                            </ng-container>
                        </lib-clipboard-card-scroll>
                    </div>
                }
            </div>
        }
    </ng-container>
    <ng-container submissionBar>
        <lib-submission-bar [kind]="SubmissionBarKind.DialogBasic">
            <lib-button
            [role]="ButtonRole.Primary"
                id="LibraryDialogSecondaryButton"
                [loading]="primaryActionClicked"
                [disabled]="!hasFiles || (data.Control !== null && data.Control.invalid)"
                (clicked)="PrimaryAction()">
                <ng-container label>
                    {{primaryButtonText}}
                </ng-container>
            </lib-button>
            <lib-button
            [role]="ButtonRole.Secondary"
                id="LibraryDialogPrimaryButton"
                [kind]="ButtonKind.Secondary"
                [disabled]="primaryActionClicked"
                (clicked)="DismissAction()">
                <ng-container label>
                    {{secondaryButtonText}}
                </ng-container>
            </lib-button>
        </lib-submission-bar>
    </ng-container>
</lib-dialog-layout>